import { DASHBOARD_LINKS } from '@/modules/Dashboard/DashboardLinks';
import useRevalidateFileDetail from '@/modules/FileDetail/hooks/useRevalidateFileDetail';
import { referToBranchActionMutationFn } from '@/modules/FileDetail/queries/sendActions/referToBranchAction/referToBranchActionMutationFn';
import { ReferToBranchActionMutationDataType } from '@/modules/FileDetail/queries/sendActions/referToBranchAction/referToBranchActionMutationFn.types';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

const useReferToBranchActionMutation = (id: string) => {
  const { revalidateFileDetail } = useRevalidateFileDetail(id);
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (data: ReferToBranchActionMutationDataType) =>
      referToBranchActionMutationFn(data, id),
    meta: {
      successToast: 'اقدام با موفقیت انجام شد',
    },
    onSuccess: () => {
      navigate(DASHBOARD_LINKS.homePage);
      return revalidateFileDetail();
    },
  });
};

export default useReferToBranchActionMutation;
